import {
  BedDouble,
  Crown,
  House,
  LogIn,
  MapPinHouse,
  Phone,
  Plane,
  SquarePen,
  Menu,
  X,
  ChevronDown,
  ChevronRight,
  CreditCard,
  LogOut,
  Globe,
  MapPin,
} from "lucide-react";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getAllDestination } from "../api/destination.api";
import { useCookies } from "react-cookie";

const Navbar = () => {
  const location = useLocation();
  const [cookies, setCookie, removeCookie] = useCookies([
    "token",
    "user",
    "id",
    "admin",
  ]);

  const [destinations, setDestinations] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [domesticOpen, setDomesticOpen] = useState(false);
  const [internationalOpen, setInternationalOpen] = useState(false);
  const [northOpen, setNorthOpen] = useState(false);
  const [eastOpen, setEastOpen] = useState(false);
  const [westOpen, setWestOpen] = useState(false);
  const [southOpen, setSouthOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhone] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navigate = useNavigate();
  const user_id = cookies.id;

  // Static destinations - no API call needed
  useEffect(() => {
    // Destinations are hardcoded in arrays below, no API call needed
    setDestinations([]);
  }, []);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [mobileMenuOpen]);

  // STATIC ARRAYS YOU PROVIDED -----------------------------
  const north = [
    "Agra",
    "Amritsar",
    "Chandigarh",
    "Dalhousie",
    "Haridwar",
    "Jim Corbett",
    "Manali",
    "Mussoorie",
    "Nainital",
    "Pahalgam",
    "Shimla",
    "Srinagar",
  ];

  const east = ["Assam", "Gangtok", "Puri"];

  const west = [
    "Daman",
    "Diu",
    "Gir",
    "Goa",
    "Jaisalmer",
    "Jodhpur",
    "Kumbhalgarh",
    "Kutch",
    "Kanha",
    "Lonavala",
    "Mahabaleshwar",
    "Mount Abu",
    "Pushkar",
    "Saputara",
    "Udaipur",
  ];

  const south = ["Coorg", "Munnar", "Ooty", "Rameshwaram", "Andaman & Nicobar"];

  const international = [
    "Amsterdam",
    "Australia",
    "Bali",
    "Budapest",
    "California",
    "Dubai",
    "Krabi",
    "Malaysia",
    "Maldives",
    "Paris",
    "Phuket",
    "Sri Lanka",
    "Switzerland",
  ];

  // --------------------------------------------------------

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Don't close dropdowns when clicking inside mobile menu
      if (event.target.closest(".mobile-menu")) {
        return;
      }

      if (!event.target.closest(".nav-dropdown")) {
        setDropdownOpen(false);
        setDomesticOpen(false);
        setInternationalOpen(false);
        setNorthOpen(false);
        setEastOpen(false);
        setWestOpen(false);
        setSouthOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLogout = () => {
    removeCookie("token");
    removeCookie("user");
    navigate("/login");
  };

  const handlePayment = async () => {
    if (!amount || !name || !email || !phone_no) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const res = await fetch(
        "/api/payment_details/create-order",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: parseFloat(amount) }),
        },
      );

      if (!res.ok) throw new Error(`API Error: ${res.status}`);

	      const data = await res.json();

      const options = {
        key: "rzp_live_RjYrSx5rHQyYuu",
        amount: data.amount * 100,
        currency: data.currency,
        name: "Aacore Resorts And Hospitality Pvt. Ltd.",
        description: "Payment",
        order_id: data.orderId,
        handler: async function (response) {
          const verifyRes = await fetch(
            "/api/payment_details/verify-payment",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                amount: parseFloat(amount),
                name,
                email,
                phone_no,
                user_id,
              }),
            },
          );
          const verifyData = await verifyRes.json();
          if (verifyData.success) {
            alert("Payment successful 🎉");
            setShowModal(false);
          } else {
            alert("Payment failed ❌");
          }
        },
        prefill: { name, email, contact: phone_no },
        theme: { color: "#3399cc" },
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.open();
    } catch (err) {
      console.error("Payment Error:", err);
      alert("Payment initialization failed.");
    }
  };

  const closeAllDropdowns = () => {
    setDropdownOpen(false);
    setDomesticOpen(false);
    setInternationalOpen(false);
    setNorthOpen(false);
    setEastOpen(false);
    setWestOpen(false);
    setSouthOpen(false);
  };

  const NavLink = ({ to, children, onClick }) => (
    <Link
      to={to}
      onClick={onClick}
      className={`nav-link-item ${location.pathname === to ? "active" : ""}`}
    >
      <span>{children}</span>
    </Link>
  );

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Avenue:wght@400;600;700&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .modern-navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          background: ${scrolled ? "rgba(255, 255, 255, 0.98)" : "rgba(255, 255, 255, 0.95)"};
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          box-shadow: ${scrolled ? "0 4px 30px rgba(0, 0, 0, 0.1)" : "0 2px 20px rgba(0, 0, 0, 0.05)"};
          transition: all 0.3s ease;
          border-bottom: 1px solid rgba(102, 126, 234, 0.1);
          display: block;
          visibility: visible;
        }

        .navbar-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 75px;
        }

        .navbar-brand {
          display: flex;
          align-items: center;
          gap: 12px;
          text-decoration: none;
          transition: transform 0.3s ease;
        }

        .navbar-brand:hover {
          transform: scale(1.02);
        }

        .brand-logo {
          height: 50px;
          width: auto;
          object-fit: contain;
        }

        .brand-text {
          font-family: 'Playfair Display', serif;
          font-size: clamp(14px, 2vw, 20px);
          font-weight: 700;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          letter-spacing: 0.3px;
          line-height: 1.2;
        }

        .nav-links {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .nav-link-item {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 16px;
          text-decoration: none;
          color: #4a5568;
          font-weight: 500;
          font-size: 14px;
          font-family: 'Inter', sans-serif;
          border-radius: 12px;
          transition: all 0.3s ease;
          position: relative;
          white-space: nowrap;
        }

        .nav-link-item:hover {
          color: #667eea;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
          transform: translateY(-2px);
        }

        .nav-link-item.active {
          color: #667eea;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15));
        }

        .nav-link-item.active::after {
          content: '';
          position: absolute;
          bottom: 6px;
          left: 50%;
          transform: translateX(-50%);
          width: 20px;
          height: 3px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          border-radius: 2px;
        }

        .nav-dropdown {
          position: relative;
        }

        .dropdown-trigger {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 16px;
          color: #4a5568;
          font-weight: 500;
          font-size: 14px;
          font-family: 'Inter', sans-serif;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: none;
          border: none;
        }

        .dropdown-trigger:hover {
          color: #667eea;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
        }

        .dropdown-trigger svg:last-child {
          transition: transform 0.3s ease;
        }

        .dropdown-trigger.open svg:last-child {
          transform: rotate(180deg);
        }

        .mega-menu {
          position: absolute;
          top: calc(100% + 10px);
          left: 50%;
          transform: translateX(-50%);
          background: white;
          border-radius: 20px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
          padding: 24px;
          min-width: 800px;
          max-width: 90vw;
          max-height: 70vh;
          overflow-y: auto;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          border: 1px solid rgba(102, 126, 234, 0.1);
        }

        .mega-menu::-webkit-scrollbar {
          display: none;
        }

        .mega-menu {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .mega-menu.open {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }

        .mega-menu-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
        }

        .menu-section {
          padding: 16px;
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          border-radius: 16px;
          transition: all 0.3s ease;
        }

        .menu-section:hover {
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.05), rgba(118, 75, 162, 0.05));
        }

        .section-header {
          display: flex;
          align-items: center;
          gap: 10px;
          padding-bottom: 12px;
          border-bottom: 2px solid rgba(102, 126, 234, 0.2);
          margin-bottom: 12px;
          cursor: pointer;
        }

        .section-header h4 {
          font-family: 'Inter', sans-serif;
          font-size: 15px;
          font-weight: 600;
          color: #1a202c;
          margin: 0;
        }

        .section-header svg {
          color: #667eea;
        }

        .section-content {
          display: none;
        }

        .section-content.open {
          display: block;
        }

        .region-group {
          margin-bottom: 12px;
        }

        .region-title {
          font-family: 'Inter', sans-serif;
          font-size: 12px;
          font-weight: 600;
          color: #667eea;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 8px;
          padding-left: 4px;
        }

        .destination-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 4px;
        }

        .destination-link {
          display: block;
          padding: 8px 12px;
          color: #4a5568;
          text-decoration: none;
          font-family: 'Inter', sans-serif;
          font-size: 13px;
          font-weight: 500;
          border-radius: 8px;
          transition: all 0.2s ease;
        }

        .destination-link:hover {
          color: #667eea;
          background: white;
          transform: translateX(4px);
          box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
        }

        .auth-buttons {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-left: 16px;
          padding-left: 16px;
          border-left: 1px solid rgba(102, 126, 234, 0.2);
        }

        .btn-pay {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 20px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          color: white;
          border: none;
          border-radius: 12px;
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }

        .btn-pay:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }

        .btn-logout {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 16px;
          background: transparent;
          color: #e53e3e;
          border: 2px solid #e53e3e;
          border-radius: 12px;
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .btn-logout:hover {
          background: #e53e3e;
          color: white;
        }

        .btn-login {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 20px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          color: white;
          border: none;
          border-radius: 12px;
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: 14px;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }

        .btn-login:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
          color: white;
        }

        .mobile-toggle {
          display: none;
          padding: 8px;
          background: none;
          border: none;
          color: #4a5568;
          cursor: pointer;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .mobile-toggle:hover {
          background: rgba(102, 126, 234, 0.1);
          color: #667eea;
        }

        .mobile-menu {
          display: none;
          position: fixed;
          top: 75px;
          left: 0;
          right: 0;
          bottom: 0;
          background: white;
          padding: 24px;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          -ms-overflow-style: none;
          animation: slideIn 0.3s ease;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .mobile-menu::-webkit-scrollbar {
          display: none;
        }

        .mobile-menu.open {
          display: block !important;
          z-index: 9998 !important;
        }

        .mobile-nav-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;
          color: #4a5568;
          text-decoration: none;
          font-weight: 500;
          font-size: 16px;
          font-family: 'Inter', sans-serif;
          border-radius: 12px;
          margin-bottom: 8px;
          transition: all 0.3s ease;
        }

        .mobile-nav-link:hover,
        .mobile-nav-link.active {
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
          color: #667eea;
        }

        .mobile-nav-link svg:first-child {
          margin-right: 12px;
        }

        .mobile-dropdown-content {
          padding-left: 20px;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }

        .mobile-dropdown-content.open {
          max-height: 2000px !important;
          display: block !important;
        }

        .mobile-region-title {
          font-size: 14px;
          font-weight: 600;
          color: #667eea;
          text-transform: uppercase;
          letter-spacing: 1px;
          padding: 12px 16px 8px;
          margin-top: 8px;
          border-top: 1px solid #f0f0f0;
        }

        .mobile-dest-link {
          display: block;
          padding: 10px 24px;
          color: #4a5568;
          text-decoration: none;
          font-size: 16px;
          font-weight: 400;
          font-family: 'Avenue', sans-serif;
          border-radius: 8px;
          transition: all 0.2s ease;
          margin: 2px 8px;
        }

        .mobile-dest-link:hover {
          background: rgba(102, 126, 234, 0.1);
          color: #667eea;
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .modal-container {
          background: white;
          border-radius: 24px;
          width: 90%;
          max-width: 450px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          animation: scaleIn 0.3s ease;
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .modal-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 24px;
          border-bottom: 1px solid #e2e8f0;
        }

        .modal-header h3 {
          font-size: 20px;
          font-weight: 700;
          color: #1a202c;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .modal-header h3 svg {
          color: #667eea;
        }

        .modal-close {
          background: none;
          border: none;
          color: #a0aec0;
          cursor: pointer;
          padding: 8px;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .modal-close:hover {
          background: #f7fafc;
          color: #4a5568;
        }

        .modal-body {
          padding: 24px;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: #4a5568;
          margin-bottom: 8px;
        }

        .form-group input {
          width: 100%;
          padding: 14px 16px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 15px;
          transition: all 0.3s ease;
        }

        .form-group input:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        }

        .modal-footer {
          display: flex;
          gap: 12px;
          padding: 24px;
          border-top: 1px solid #e2e8f0;
        }

        .btn-cancel {
          flex: 1;
          padding: 14px 24px;
          background: #f7fafc;
          color: #4a5568;
          border: none;
          border-radius: 12px;
          font-weight: 600;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .btn-cancel:hover {
          background: #edf2f7;
        }

        .btn-submit {
          flex: 1;
          padding: 14px 24px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          color: white;
          border: none;
          border-radius: 12px;
          font-weight: 600;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }

        .btn-submit:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }

        @media (max-width: 1200px) {
          .modern-navbar {
            display: block !important;
            visibility: visible !important;
          }
          
          .nav-links {
            display: none;
          }

          .auth-buttons {
            display: none;
          }

          .mobile-toggle {
            display: block;
          }

          .mega-menu {
            min-width: 600px;
          }
        }

        @media (max-width: 992px) {
          .navbar-container {
            padding: 0 20px;
          }

          .brand-text {
            font-size: 16px;
          }

          .mega-menu {
            min-width: 500px;
            max-width: 95vw;
          }

          .mega-menu-grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }

          .destination-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .modern-navbar {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            z-index: 9999 !important;
          }
          
          .navbar-container {
            padding: 0 16px;
            height: 60px;
          }

          .brand-text {
            font-size: 18px;
            line-height: 1.1;
          }
          
          .brand-logo {
            height: 35px;
          }

          .mobile-menu {
            top: 60px;
            padding: 20px 16px;
          }

          .mobile-nav-link {
            padding: 14px 12px;
            font-size: 15px;
          }

          .mobile-dropdown-content {
            padding-left: 16px;
          }

          .mobile-dest-link {
            padding: 8px 20px;
            font-size: 15px;
            font-weight: 400;
          }

          .modal-container {
            width: 95%;
            margin: 0 16px;
          }

          .modal-header,
          .modal-body,
          .modal-footer {
            padding: 20px;
          }
        }

        @media (max-width: 600px) {
          .navbar-container {
            padding: 0 12px;
            height: 55px;
          }
          
          .brand-text {
            font-size: 16px;
            max-width: none;
            overflow: visible;
            text-overflow: unset;
            white-space: normal;
            line-height: 1.1;
          }

          .brand-logo {
            height: 30px;
          }
          
          .mobile-menu {
            top: 55px;
            padding: 16px 12px;
          }
          
          .mobile-nav-link {
            padding: 12px 8px;
            font-size: 14px;
          }

          .mobile-dropdown-content {
            padding-left: 12px;
          }

          .mobile-dest-link {
            padding: 6px 16px;
            font-size: 14px;
            font-weight: 400;
          }

          .mobile-region-title {
            font-size: 12px;
            padding: 10px 12px 6px;
          }

          .modal-container {
            width: 98%;
            margin: 0 8px;
          }

          .modal-header h3 {
            font-size: 18px;
          }

          .form-group input {
            padding: 12px 14px;
            font-size: 14px;
          }

          .btn-submit,
          .btn-cancel {
            padding: 12px 20px;
            font-size: 14px;
          }
        }

        @media (max-width: 480px) {
          .navbar-container {
            padding: 0 10px;
            height: 50px;
          }

          .brand-text {
            font-size: 13px;
            max-width: none;
            overflow: visible;
            text-overflow: unset;
            white-space: normal;
          }

          .brand-logo {
            height: 28px;
          }

          .mobile-toggle {
            padding: 6px;
          }

          .mobile-menu {
            top: 50px;
            padding: 12px 8px;
          }

          .mobile-nav-link {
            padding: 10px 6px;
            font-size: 13px;
          }

          .mobile-dest-link {
            padding: 5px 12px;
            font-size: 13px;
            font-weight: 400;
          }

          .mobile-region-title {
            font-size: 11px;
            padding: 8px 10px 4px;
          }

          .modal-container {
            width: 100%;
            margin: 0;
            border-radius: 16px;
          }

          .modal-header,
          .modal-body,
          .modal-footer {
            padding: 16px;
          }

          .form-group {
            margin-bottom: 16px;
          }

          .form-group input {
            padding: 10px 12px;
            font-size: 13px;
          }

          .btn-submit,
          .btn-cancel {
            padding: 10px 16px;
            font-size: 13px;
          }
        }

        @media (max-width: 360px) {
          .navbar-container {
            padding: 0 8px;
            height: 48px;
          }

          .brand-text {
            font-size: 10px;
            max-width: none;
            overflow: visible;
            text-overflow: unset;
            white-space: normal;
          }

          .brand-logo {
            height: 25px;
          }

          .mobile-menu {
            top: 48px;
            padding: 10px 6px;
          }

          .mobile-nav-link {
            padding: 8px 4px;
            font-size: 12px;
          }

          .mobile-dest-link {
            padding: 4px 10px;
            font-size: 12px;
            font-weight: 400;
          }

          .mobile-region-title {
            font-size: 10px;
            padding: 6px 8px 3px;
          }

          .modal-header h3 {
            font-size: 16px;
          }

          .form-group input {
            padding: 8px 10px;
            font-size: 12px;
          }

          .btn-submit,
          .btn-cancel {
            padding: 8px 12px;
            font-size: 12px;
          }
        }
      `}</style>

      <nav className={`modern-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">
          <Link to="/" className="navbar-brand" onClick={handleLogoClick}>
            <img
              src="/assets/images/AacoreHoliday.png"
              alt="Aacore Holidays"
              className="brand-logo"
            />
            <span className="brand-text">
              Aacore Holidays & Resort Pvt. Ltd.
            </span>
          </Link>

          <div className="nav-links">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/about">About</NavLink>

            {/* Destinations Mega Menu */}
            <div
              className="nav-dropdown"
              onMouseEnter={() => {
                setDropdownOpen(true);
                setDomesticOpen(true);
                setInternationalOpen(true);
              }}
              onMouseLeave={() => setDropdownOpen(false)}
            >
              <button
                className={`dropdown-trigger ${dropdownOpen ? "open" : ""}`}
              >
                <span>Destinations</span>
                <ChevronDown size={16} />
              </button>

              <div className={`mega-menu ${dropdownOpen ? "open" : ""}`}>
                <div className="mega-menu-grid">
                  {/* Domestic Section */}
                  <div className="menu-section">
                    <div
                      className="section-header"
                      onClick={() => setDomesticOpen(!domesticOpen)}
                    >
                      <MapPin size={20} />
                      <h4>Domestic</h4>
                      <ChevronRight
                        size={16}
                        style={{
                          transform: domesticOpen ? "rotate(90deg)" : "none",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    </div>
                    <div
                      className={`section-content ${domesticOpen ? "open" : ""}`}
                    >
                      {/* North */}
                      <div className="region-group">
                        <div className="region-title">North India</div>
                        <div className="destination-grid">
                          {north.map((dest) => (
                            <Link
                              key={dest}
                              to={`/destinations/${dest.toLowerCase().replace(/\s+/g, "")}`}
                              className="destination-link"
                              onClick={closeAllDropdowns}
                            >
                              {dest}
                            </Link>
                          ))}
                        </div>
                      </div>
                      {/* East */}
                      <div className="region-group">
                        <div className="region-title">East India</div>
                        <div className="destination-grid">
                          {east.map((dest) => (
                            <Link
                              key={dest}
                              to={`/destinations/${dest.toLowerCase().replace(/\s+/g, "")}`}
                              className="destination-link"
                              onClick={closeAllDropdowns}
                            >
                              {dest}
                            </Link>
                          ))}
                        </div>
                      </div>
                      {/* West */}
                      <div className="region-group">
                        <div className="region-title">West India</div>
                        <div className="destination-grid">
                          {west.map((dest) => (
                            <Link
                              key={dest}
                              to={`/destinations/${dest.toLowerCase().replace(/\s+/g, "")}`}
                              className="destination-link"
                              onClick={closeAllDropdowns}
                            >
                              {dest}
                            </Link>
                          ))}
                        </div>
                      </div>
                      {/* South */}
                      <div className="region-group">
                        <div className="region-title">South India</div>
                        <div className="destination-grid">
                          {south.map((dest) => (
                            <Link
                              key={dest}
                              to={`/destinations/${dest === "Andaman & Nicobar" ? "andaman&nicobar" : dest.toLowerCase().replace(/\s+/g, "")}`}
                              className="destination-link"
                              onClick={closeAllDropdowns}
                            >
                              {dest}
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* International Section */}
                  <div className="menu-section">
                    <div
                      className="section-header"
                      onClick={() => setInternationalOpen(!internationalOpen)}
                    >
                      <Globe size={20} />
                      <h4>International</h4>
                      <ChevronRight
                        size={16}
                        style={{
                          transform: internationalOpen
                            ? "rotate(90deg)"
                            : "none",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    </div>
                    <div
                      className={`section-content ${internationalOpen ? "open" : ""}`}
                    >
                      <div className="destination-grid">
                        {international.map((dest) => (
                          <Link
                            key={dest}
                            to={`/destinations/${dest.toLowerCase().replace(/\s+/g, "")}`}
                            className="destination-link"
                            onClick={closeAllDropdowns}
                          >
                            {dest}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <NavLink to="/travelthemes">Themes</NavLink>
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/hotel">Hotels</NavLink>
            <NavLink to="/ourproduct">Membership</NavLink>
            <NavLink to="/contact">Contact</NavLink>
          </div>

          <div className="auth-buttons">
            <button className="btn-pay" onClick={() => setShowModal(true)}>
              <CreditCard size={18} />
              Pay
            </button>
            {cookies.token ? (
              <button className="btn-logout" onClick={handleLogout}>
                <LogOut size={18} />
                Logout
              </button>
            ) : (
              <Link to="/login" className="btn-login">
                <LogIn size={18} />
                Login
              </Link>
            )}
          </div>

          <button
            className="mobile-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
        <Link
          to="/"
          className={`mobile-nav-link ${location.pathname === "/" ? "active" : ""}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          <span>Home</span>
        </Link>

        <Link
          to="/about"
          className={`mobile-nav-link ${location.pathname === "/about" ? "active" : ""}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          <span>About</span>
        </Link>

        <div
          className="mobile-nav-link"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <span>Destinations</span>
          <ChevronDown
            size={20}
            style={{
              transform: dropdownOpen ? "rotate(180deg)" : "none",
              transition: "transform 0.3s ease",
            }}
          />
        </div>

        <div
          className={`mobile-dropdown-content ${dropdownOpen ? "open" : ""}`}
        >
          <div
            className="mobile-nav-link"
            onClick={() => setDomesticOpen(!domesticOpen)}
            style={{ paddingLeft: "32px" }}
          >
            <span>Domestic</span>
            <ChevronDown
              size={16}
              style={{
                transform: domesticOpen ? "rotate(180deg)" : "none",
                transition: "transform 0.3s ease",
              }}
            />
          </div>

          <div
            className={`mobile-dropdown-content ${domesticOpen ? "open" : ""}`}
          >
            <div className="mobile-region-title">North</div>
            {north.map((dest) => (
              <Link
                key={dest}
                to={`/destinations/${dest.toLowerCase().replace(/\s+/g, "")}`}
                className="mobile-dest-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                {dest}
              </Link>
            ))}
            <div className="mobile-region-title">East</div>
            {east.map((dest) => (
              <Link
                key={dest}
                to={`/destinations/${dest.toLowerCase().replace(/\s+/g, "")}`}
                className="mobile-dest-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                {dest}
              </Link>
            ))}
            <div className="mobile-region-title">West</div>
            {west.map((dest) => (
              <Link
                key={dest}
                to={`/destinations/${dest.toLowerCase().replace(/\s+/g, "")}`}
                className="mobile-dest-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                {dest}
              </Link>
            ))}
            <div className="mobile-region-title">South</div>
            {south.map((dest) => (
              <Link
                key={dest}
                to={`/destinations/${dest === "Andaman & Nicobar" ? "andaman&nicobar" : dest.toLowerCase().replace(/\s+/g, "")}`}
                className="mobile-dest-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                {dest}
              </Link>
            ))}
          </div>

          <div
            className="mobile-nav-link"
            onClick={() => setInternationalOpen(!internationalOpen)}
            style={{ paddingLeft: "32px" }}
          >
            <span>International</span>
            <ChevronDown
              size={16}
              style={{
                transform: internationalOpen ? "rotate(180deg)" : "none",
                transition: "transform 0.3s ease",
              }}
            />
          </div>

          <div
            className={`mobile-dropdown-content ${internationalOpen ? "open" : ""}`}
          >
            {international.map((dest) => (
              <Link
                key={dest}
                to={`/destinations/${dest.toLowerCase().replace(/\s+/g, "")}`}
                className="mobile-dest-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                {dest}
              </Link>
            ))}
          </div>
        </div>

        <Link
          to="/travelthemes"
          className={`mobile-nav-link ${location.pathname === "/travelthemes" ? "active" : ""}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          <span>Themes</span>
        </Link>

        <Link
          to="/services"
          className={`mobile-nav-link ${location.pathname === "/services" ? "active" : ""}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          <span>Services</span>
        </Link>

        <Link
          to="/hotel"
          className={`mobile-nav-link ${location.pathname === "/hotel" ? "active" : ""}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          <span>Hotels</span>
        </Link>

        <Link
          to="/ourproduct"
          className={`mobile-nav-link ${location.pathname === "/ourproduct" ? "active" : ""}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          <span>Membership</span>
        </Link>

        <Link
          to="/contact"
          className={`mobile-nav-link ${location.pathname === "/contact" ? "active" : ""}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          <span>Contact</span>
        </Link>

        <div
          style={{
            padding: "16px",
            borderTop: "1px solid #e2e8f0",
            marginTop: "16px",
          }}
        >
          <button
            className="btn-pay"
            style={{
              width: "100%",
              justifyContent: "center",
              marginBottom: "12px",
            }}
            onClick={() => {
              setShowModal(true);
              setMobileMenuOpen(false);
            }}
          >
            <CreditCard size={18} />
            Pay
          </button>
          {cookies.token ? (
            <button
              className="btn-logout"
              style={{ width: "100%", justifyContent: "center" }}
              onClick={handleLogout}
            >
              <LogOut size={18} />
              Logout
            </button>
          ) : (
            <Link
              to="/login"
              className="btn-login"
              style={{ width: "100%", justifyContent: "center" }}
              onClick={() => setMobileMenuOpen(false)}
            >
              <LogIn size={18} />
              Login
            </Link>
          )}
        </div>
      </div>

      {/* Payment Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>
                <CreditCard size={24} />
                Pay Online
              </h3>
              <button
                className="modal-close"
                onClick={() => setShowModal(false)}
              >
                <X size={24} />
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Amount (₹)</label>
                <input
                  type="number"
                  placeholder="Enter amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  min="1"
                  max="10000000"
                  step="1"
                />
              </div>

              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  placeholder="Enter your phone"
                  value={phone_no}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn-cancel"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="btn-submit" onClick={handlePayment}>
                Pay Now
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Spacer for fixed navbar */}
      <div
        style={{
          height:
            window.innerWidth <= 480
              ? "50px"
              : window.innerWidth <= 600
                ? "55px"
                : window.innerWidth <= 768
                  ? "60px"
                  : "75px",
        }}
      />
    </>
  );
};

export default Navbar;
